import { useEffect, useState } from 'react';
import { isMobile as isMobileDevice } from 'react-device-detect';

const useCheckMobileScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobileDevice || width < 768;
};

export default useCheckMobileScreen;
